/**
 * One-level folder nesting (e.g. Market -> Advertiser sub-folder), gated per
 * account by the `enable-subfolders` setting (boolean-string convention, same
 * as `enable-v3-ui`).
 *
 * The flag gates creating/moving sub-folders. Display helpers below work off
 * `parent_id`/`parent_name` returned by /api/v2/folders regardless of the
 * flag, so any existing sub-folders keep rendering if the flag is removed.
 */
export const ENABLE_SUBFOLDERS_KEY = 'enable-subfolders';

export function isSubfoldersEnabled(accountSettings) {
  return accountSettings?.[ENABLE_SUBFOLDERS_KEY] === 'true';
}

/**
 * Label for folder pickers and lists: sub-folders show their parent for
 * context ("EMEA / Acme Motors"), top-level folders show just their name.
 * Works row-by-row, so it does not depend on the parent being present in the
 * same (possibly paginated) list.
 */
export function getFolderDisplayLabel(folder) {
  if (!folder) return '';
  return folder.parent_name ? `${folder.parent_name} / ${folder.name}` : folder.name;
}
